/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Number employees/rooms required for a product
 */
export const SpaProductResourceCountDTO = {
    NONE: 'NONE',
    ONE: 'ONE',
    ONE_PER_GUEST: 'ONE_PER_GUEST'
} as const;
export type SpaProductResourceCountDTO = typeof SpaProductResourceCountDTO[keyof typeof SpaProductResourceCountDTO];

